import {useMutation} from 'react-query';
import {client} from './ApiClient';
import {ClubPreferences} from "../Helpers/Types";
import {SnippetAuth} from "./SnippetAuth";

// The cart comes from the snippet's session (or cart Uid), so no cart id is sent.
const setClubPreferences = ({urls, auth, lineUid, preferences}: {urls: any; auth: SnippetAuth | undefined; lineUid: string; preferences: ClubPreferences}) => {
    if (!auth)
        return Promise.reject('A snippet session key is required.')

    return client(urls.LoyaltyEngineApiUrl, 'v5/snippets/carts/commands/setclubpreferences', {
        ...auth,
        body: {
            LineUid: lineUid,
            ...preferences
        }
    });
}

export default function useSetClubPreferences() {
    // @ts-ignore
    return useMutation(setClubPreferences)
}
